import React from 'react';
import 'styles/common.css';
import './Services.css';

const ServicePage = () => {

  const navigateToLogIn = () => {
    const url = 'http://3.133.131.124:3000/login';
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const services = [
    {
      id: 1,
      title: 'Quantum Calculations and Spectroscopic Analysis',
      description: 'We perform high-precision quantum mechanical (QM) calculations and spectral simulations (IR, NMR, UV-Vis, Raman) to support the structural elucidation and electronic property analysis of drug molecules, assisting experimental validation and compound characterization.'
    },
    {
      id: 2,
      title: 'AI-Based Small Molecule Drug Design',
      description: 'Our proprietary AI-driven platform enables de novo small-molecule generation and lead discovery, combining graph neural networks and large language models (LLMs) for efficient exploration of chemical space and identification of novel, synthetically accessible compounds.',
      video: 'https://genion-assets.s3.us-east-2.amazonaws.com/small-molecule-design.mp4',
      poster: '/videoPosters/small-malecule.png'
    },
    {
      id: 3,
      title: 'AI-Guided Molecular Optimization',
      description: 'Using advanced reinforcement learning and matched molecular pair (MMP) analysis, we perform multi-objective molecular optimization—enhancing potency, selectivity, solubility, and overall drug-likeness while maintaining chemical feasibility.'
    },
    {
      id: 4,
      title: 'Drug Property Prediction and Evaluation',
      description: 'We provide comprehensive in silico pharmacological profiling, including physicochemical, pharmacokinetic, and safety property predictions, ensuring each compound meets preclinical development standards.'
    },
    {
      id: 5,
      title: 'ADMET Profile Optimization',
      description: 'Our AI-driven ADMET prediction and optimization tools evaluate and refine absorption, distribution, metabolism, excretion, and toxicity properties to accelerate progression of compounds with favorable pharmacokinetic and safety characteristics.'
    },
    {
      id: 6,
      title: 'Structure-Based Modeling of Ligand–Target Interactions',
      description: 'Leveraging docking, quantum-refined scoring, and binding free energy analysis, we conduct high-resolution modeling of ligand-target interactions to elucidate binding mechanisms and guide rational drug design.'
    },
    {
      id: 7,
      title: 'AI Design of Peptide Therapeutics',
      description: 'We develop AI-assisted peptide design pipelines for bioactive peptide discovery and modification, integrating structural modeling and generative design to optimize stability, binding affinity, and therapeutic efficacy.',
      video: 'https://genion-assets.s3.us-east-2.amazonaws.com/peptide-instruction.mp4',
      poster: '/videoPosters/peptide.png'
    },
    {
      id: 8,
      title: 'Peptide Property Prediction and Evaluation',
      description: 'Our AI and docking hybrid models predict key peptide properties, including solubility, stability, cell permeability, and immunogenicity, to streamline candidate selection and experimental validation.'
    },
    {
      id: 9,
      title: 'Structure-Based Modeling of Protein–Protein Interactions',
      description: 'We employ structure-based computational modeling to characterize and modulate protein-protein interactions (PPIs), supporting the design of peptide or small-molecule PPI modulators for therapeutic targeting.'
    },
    {
      id: 10,
      title: 'Molecular Dynamics (MD) and Metadynamics Simulations',
      description: 'We perform all-atom molecular dynamics simulations combined with metadynamics for free energy landscape exploration and binding free energy evaluations, enabling accurate assessment of molecular stability and interaction strength.'
    }
  ];

  return (
    <div className="service-page">
      {/* Header with Login Button */}
      <div className="service-header">
        <div className="service-header-top">
          <h1 className="service-title">Services</h1>
          <button className="btn btn-primary login-btn" onClick={navigateToLogIn}>
            Log In
          </button>
        </div>
        <p className="service-subtitle">Genion Quantum Technologies</p>
      </div>

      {/* Services List */}
      <div className="services-list">
        {services.map((service) => (
          <div key={service.id} className="service-item">
            <div className="service-number">0{service.id}</div>
            <div className="service-content">
              <h3 className="service-item-title">{service.title}</h3>
              <p className="service-item-description">{service.description}</p>

              {/* Video Section for Specific Services */}
              {service.video && (
                service.video.includes('youtube.com') || service.video.includes('youtu.be') ? (
                  <iframe
                    width="600"
                    height="350"
                    src={service.video}
                    title={service.title}
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  />
                ) : (
                  <div className="service-video-container">
                    <video
                      className="service-video"
                      controls
                      muted
                      preload="none"
                      poster={service.poster}
                    >
                      <source src={service.video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    <p className="video-caption">Watch how our {service.title.toLowerCase()} platform works</p>
                  </div>
                )
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicePage;